import { render, staticRenderFns } from "./SendGiftcardCard.vue?vue&type=template&id=33aec691"
import script from "./SendGiftcardCard.vue?vue&type=script&lang=js"
export * from "./SendGiftcardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports